import * as React from 'react'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import useMediaQuery from '@mui/material/useMediaQuery'

import { UserContext } from '../../UserContext'
import { appProductName } from '../../appVariant'

// Treat the two known product names as "no override" so APP_VARIANT always
// wins over a stale stored value (e.g. legacy users still have
// customization='InfraNodus' even after switching variant to keywordgraph).
const KNOWN_PRODUCT_NAMES = new Set(['InfraNodus', 'KeywordGraph'])

export default function AppName() {
    const { customization } = React.useContext(UserContext)
    const isMobile = useMediaQuery('(max-width:600px)')

    if (isMobile) return null

    const hasRealOverride =
        typeof customization === 'string' &&
        customization.trim() !== '' &&
        !KNOWN_PRODUCT_NAMES.has(customization.trim())

    const displayName = hasRealOverride ? customization : appProductName()

    const handleClick = () => {
        if (
            typeof window !== 'undefined' &&
            window.myEventEmitter &&
            typeof window.myEventEmitter.emit === 'function'
        ) {
            window.myEventEmitter.emit('clickInfraNodus')
        }
    }

    return (
        <Tooltip title="Customize this name in your settings" arrow={false}>
            <Typography
                id="appNameDisplay"
                onClick={handleClick}
                sx={{
                    cursor: 'pointer',
                    fontWeight: 600,
                    color: 'text.primary',
                    px: 1.5,
                    alignSelf: 'center',
                    userSelect: 'none',
                    whiteSpace: 'nowrap',
                }}
            >
                {displayName}
            </Typography>
        </Tooltip>
    )
}
